<app-admin-form [title]="'Leveranciers Artikelen'" [object]="supplierInterfaceData">
  <!-- <ng-template #dropdownTemplate let-model='model'>
    <span *ngIf="model; else noneSelected">{{model?.Name}}</span>
    <ng-template #noneSelected>niets gekozen</ng-template>
  </ng-template> -->
  <!-- <app-admin-custom-control [label]="'Soort koppeling'">
    <div class="row gy-2 gx-3 align-items-center">
      <div class="col-auto">
        <app-admin-dropdown [(model)]="interfaceKindInfo" [modelValues]="interfaceKinds" [modelDisplayProperty]="'Name'"
          [modelEmptyDisplayValue]="'Kies een koppeling...'"
          (modelChange)="suppliers=getSuppliers(interfaceKindInfo.InterfaceKind)" [dividerKind]="-1">
        </app-admin-dropdown>
      </div>
      @if (interfaceKindInfo?.InterfaceKind!==22 && suppliers && suppliers.length>1) {
      <div class="col-auto">
        <app-admin-dropdown [(model)]="supplier" [modelValues]="suppliers" [modelValueProperty]="'id'"
          [modelDisplayProperty]="'name'" [modelEmptyDisplayValue]="'Kies een leverancier...'"
          (modelChange)="branches=getBranches(interfaceKindInfo.InterfaceKind, supplier)" [dividerKind]="-1">
        </app-admin-dropdown>
      </div>
      }
      @if (branches && branches.length>1) {
      <div class="col-auto">
        <app-admin-dropdown [(model)]="branch" [modelValues]="branches" [modelValueProperty]="'id'"
          [modelDisplayProperty]="'name'" [modelEmptyDisplayValue]="'Kies een filiaal...'" [dividerKind]="-1">
        </app-admin-dropdown>
      </div>
      }
    </div>
  </app-admin-custom-control> -->





</app-admin-form>